import { INIT_PAGE_STATE } from "../../../constants/constants";

import {
  ADDEDIT_MASTER_CITY,
  CLOSE_ADDEDIT_MASTER_CITY,
  LOAD_MASTER_CITY_LIST,
  LOAD_MASTER_CITY_LIST_ERROR,
  LOAD_MASTER_CITY_LIST_SUCCESS,
  DELETE_MASTER_CITY,
  DELETE_MASTER_CITY_ERROR,
  DELETE_MASTER_CITY_SUCCESS,
  SAVE_ADDEDIT_MASTER_CITY,
  SAVE_ADDEDIT_MASTER_CITY_ERROR,
  SAVE_ADDEDIT_MASTER_CITY_SUCCESS,
  ADDEDIT_MASTER_CITY_SUCCESS,
  ADDEDIT_MASTER_CITY_ERROR,
  GET_MASTER_PROVINCE_LIST,
  GET_MASTER_PROVINCE_LIST_SUCCESS,
  GET_MASTER_PROVINCE_LIST_ERROR,
} from "./action";

const INIT_STATE = {
  list: {
    data: null,
    loading: false,
    error: false,
    filter: null,
    orderBy: null,
    sortedBy: "asc",
    filterFields: "name:ilike;mProvince.name:ilike;zipcode:ilike",
    searchJoin: "or",
    page: INIT_PAGE_STATE,
    message: null,
  },
  addEdit: {
    data: null,
    mode: "add",
    loading: false,
    error: false,
    message: null,
  },
  deleting: {
    data: null,
    loading: false,
    error: false,
    message: null,
    confirmed: false,
  },
  listProvince: {
    data: null,
    loading: false,
    error: false,
    message: null,
  },
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOAD_MASTER_CITY_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          data: null,
          loading: true,
          error: false,
          filter: action.payload.filter,
          orderBy: action.payload.orderBy,
          sortedBy: action.payload.sortedBy,
          page: INIT_PAGE_STATE,
          message: null,
        },
      };

    case LOAD_MASTER_CITY_LIST_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          data: action.payload.data.map((t) => {
            return {
              ...t,
              ...t.attributes,
            };
          }),
          page: {
            ...state.list.page,
            currentPage: action.payload.meta.pagination.current_page,
            selectedPageSize: action.payload.meta.pagination.per_page,
            totalItemCount: action.payload.meta.pagination.total,
            totalPage: action.payload.meta.pagination.total_pages,
            itemCount: action.payload.meta.pagination.count,
          },
          loading: false,
          error: false,
          message: null,
        },
      };

    case LOAD_MASTER_CITY_LIST_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          data: null,
          loading: false,
          error: true,
          page: INIT_PAGE_STATE,
          message: action.payload,
        },
      };

    case ADDEDIT_MASTER_CITY:
      return {
        ...state,
        addEdit: {
          ...state.addEdit,
          data: action.payload.item,
          mode: action.payload.mode,
          loading: false,
          error: false,
          message: null,
          provinces: null,
        },
      };

    case ADDEDIT_MASTER_CITY_SUCCESS:
      return {
        ...state,
        addEdit: {
          ...state.addEdit,
          provinces: action.payload.data.map((t) => {
            return {
              ...t,
              ...t.attributes,
            };
          }),
          loading: false,
          error: false,
          message: null,
        },
      };

    case ADDEDIT_MASTER_CITY_ERROR:
      return {
        ...state,
        addEdit: {
          ...state.addEdit,
          provinces: null,
          loading: false,
          error: true,
          message: action.payload,
        },
      };

    case SAVE_ADDEDIT_MASTER_CITY:
      return {
        ...state,
        addEdit: {
          ...state.addEdit,
          data: action.payload.item,
          loading: true,
          error: false,
          message: null,
        },
      };

    case SAVE_ADDEDIT_MASTER_CITY_SUCCESS:
      return {
        ...state,
        addEdit: {
          ...state.addEdit,
          data: null,
          loading: false,
          error: true,
        },
      };

    case SAVE_ADDEDIT_MASTER_CITY_ERROR:
      return {
        ...state,
        addEdit: {
          ...state.addEdit,
          loading: false,
          error: true,
          message: action.payload.toString(),
        },
      };

    case CLOSE_ADDEDIT_MASTER_CITY:
      return {
        ...state,
        addEdit: {
          ...state.addEdit,
          data: null,
          mode: "add",
          loading: false,
          error: false,
          message: null,
        },
      };

    case DELETE_MASTER_CITY:
      return {
        ...state,
        deleting: {
          ...state.deleting,
          data: action.payload.item,
          confirmed: action.payload.confirmed,
          loading: action.payload.confirmed,
          error: false,
          message: null,
        },
      };

    case DELETE_MASTER_CITY_SUCCESS:
      return {
        ...state,
        deleting: {
          ...state.deleting,
          data: null,
          loading: false,
          error: false,
          message: null,
          confirmed: false,
        },
      };

    case DELETE_MASTER_CITY_ERROR:
      return {
        ...state,
        deleting: {
          ...state.deleting,
          loading: false,
          error: true,
          message: action.payload,
          confirmed: false,
        },
      };

    case GET_MASTER_PROVINCE_LIST:
      return {
        ...state,
        listProvince: {
          ...state.listProvince,
          data: null,
          loading: true,
          error: false,
          message: null,
        },
      };

    case GET_MASTER_PROVINCE_LIST_SUCCESS:
      return {
        ...state,
        listProvince: {
          ...state.listProvince,
          data: action.payload.data.map((t) => {
            return {
              ...t,
            };
          }),
          loading: false,
          error: false,
          message: null,
        },
      };

    case GET_MASTER_PROVINCE_LIST_ERROR:
      return {
        ...state,
        listProvince: {
          ...state.listProvince,
          data: null,
          loading: false,
          error: true,
          page: INIT_PAGE_STATE,
          message: action.payload,
        },
      };
    default:
      return state;
  }
};
